import BoostContainer from "pages/Boost/components/BoostContainer";
import React from "react";

const BoostBlog = () => {
  return (
    <BoostContainer relative>
      <div className="flex pt-16 lg:pt-24 h-full min-h-screen">
        <main className="w-full text-white pt-16">
          <section className="mb-5 px-10 max-w-page text-center py-5">
            <h1 className="text-3xl md:text-5xl  font-extrabold w-10/12 mx-auto">
              The blog is coming soon!
            </h1>
            <p className="md:text-2xl font-light mt-2 w-full md:w-8/12 mx-auto">
              In the meantime, check out{" "}
              <a
                className="text-boost-purple-alt font-medium hover:text-purple-700"
                href="/boost#howItWorks"
              >
                How It Works!
              </a>
            </p>
          </section>
        </main>
      </div>
    </BoostContainer>
  );
};

export default BoostBlog;
